<template>
  <div class="table-responsive dashboard-table">
    <table class="table datatable">
      <thead class="thead-light">
        <tr>
          <th>Ref Id</th>
          <th>Transaction For</th>
          <th>Date</th>
          <th>Total</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>#1001</td>
          <td>
            <div class="table-avatar">
              <div class="table-head-name flex-grow-1">
                <a href="javascript:void(0);" class="mb-0">Self Deposit Paypal</a>
              </div>
            </div>
          </td>
          <td>15 Sep 2023, 09:00 AM</td>
          <td class="text-success-light">+ $300</td>
          <td>
            <span class="badge badge-light-success">Completed</span>
          </td>
        </tr>
        <tr>
          <td>#1002</td>
          <td>
            <div class="table-avatar">
              <div class="table-head-name flex-grow-1">
                <a href="javascript:void(0);" class="mb-0">Audi A3 2019 new</a>
              </div>
            </div>
          </td>
          <td>23 Oct 2023, 12:00 PM</td>
          <td class="text-danger">- $500</td>
          <td>
            <span class="badge badge-light-success">Completed</span>
          </td>
        </tr>
        <tr>
          <td>#1003</td>
          <td>
            <div class="table-avatar">
              <div class="table-head-name flex-grow-1">
                <a href="javascript:void(0);" class="mb-0">Self Deposit Stripe</a>
              </div>
            </div>
          </td>
          <td>02 Nov 2023, 10:30 AM</td>
          <td class="text-success-light">+ $600</td>
          <td>
            <span class="badge badge-light-success">Completed</span>
          </td>
        </tr>
        <tr>
          <td>#1004</td>
          <td>
            <div class="table-avatar">
              <div class="table-head-name flex-grow-1">
                <a href="javascript:void(0);" class="mb-0">Audi A3 2020 new</a>
              </div>
            </div>
          </td>
          <td>18 Dec 2023, 02:30 PM</td>
          <td class="text-success-light">+ $1500</td>
          <td>
            <span class="badge badge-light-warning">Pending</span>
          </td>
        </tr>
        <tr>
          <td>#1005</td>
          <td>
            <div class="table-avatar">
              <div class="table-head-name flex-grow-1">
                <a href="javascript:void(0);" class="mb-0">Self Deposit Stripe</a>
              </div>
            </div>
          </td>
          <td>05 Jan 2024, 08:00 AM</td>
          <td class="text-danger">- $450</td>
          <td>
            <span class="badge badge-light-danger">Failed</span>
          </td>
        </tr>
        <tr>
          <td>#1006</td>
          <td>
            <div class="table-avatar">
              <div class="table-head-name flex-grow-1">
                <a href="javascript:void(0);" class="mb-0">Self Deposit Paypal</a>
              </div>
            </div>
          </td>
          <td>20 Feb 2024, 11:30 PM</td>
          <td class="text-success-light">+ $1000</td>
          <td>
            <span class="badge badge-light-success">Completed</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
